import React from "react";
import { Dropdown, Menu } from "antd";
import { GlobalContext } from "../../context.global";
import { KETRICS_LANGUAGES } from "../../utils/constants";

interface ISelectLanguageState {}

interface ISelectLanguageProps {
  placement: "bottomRight" | "bottomCenter";
  style: React.CSSProperties;
}

class SelectLanguage extends React.Component<ISelectLanguageProps, ISelectLanguageState> {
  static defaultProps = {
    placement: "bottomRight",
    style: {}
  };
  state: ISelectLanguageState = {};

  static contextType = GlobalContext;
  context!: React.ContextType<typeof GlobalContext>;

  render() {
    const selectedLanguage = KETRICS_LANGUAGES.find((l) => l.key === this.context.locale);

    const menu = (
      <Menu>
        {KETRICS_LANGUAGES.map((lang) => (
          <Menu.Item key={lang.key} onClick={() => this.context.setLocale(lang.key)}>
            <span style={{ fontSize: 20 }}>{lang.flag}</span> {lang.title}
          </Menu.Item>
        ))}
      </Menu>
    );

    return (
      <Dropdown overlay={menu} placement={this.props.placement}>
        <a
          className="ant-dropdown-link"
          style={{ ...this.props.style, fontSize: 20 }}
          onClick={(e) => e.preventDefault()}
          href="/#"
        >
          {selectedLanguage?.flag}
        </a>
      </Dropdown>
    );
  }
}

export default SelectLanguage;
